module.exports = __webpack_public_path__ + "img/public/SiteIcons/wishlistOff.svg?d3fb306b";